import { render, staticRenderFns } from "./daterange-picker.vue?vue&type=template&id=72a8a118&scoped=true"
import script from "./daterange-picker.vue?vue&type=script&lang=js"
export * from "./daterange-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a8a118",
  null
  
)

export default component.exports